var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.equipment == 'y')?_c('yd'):_vm._e(),(_vm.equipment == 'p')?_c('pc'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }